import {
    Box,
    Flex,
    Text,
} from "@chakra-ui/react";

import Card from "./Card";

const StatCard = ({
    title,
    value,
    subtitle,
    trend,
    trendColor = "green.500",
    icon,
}) => {
    return (
        <Card>
            <Flex
                justify="space-between"
                mb={6}
            >
                <Text
                    fontSize="xs"
                    fontWeight="700"
                    color="#2453FF"
                    letterSpacing="1px"
                    textTransform="uppercase"
                >
                    {title}
                </Text>

                {icon && (
                    <Box
                        p={2}
                        bg="#EEF4FF"
                        borderRadius="10px"
                    >
                        {icon}
                    </Box>
                )}
            </Flex>

            <Text
                fontSize="28px"
                fontWeight="700"
                color="#071D54"
            >
                {value}
            </Text>

            <Flex
                gap={2}
                mt={2}
                align="center"
            >
                {trend && (
                    <Text
                        color={trendColor}
                        fontWeight="600"
                        fontSize="sm"
                    >
                        {trend}
                    </Text>
                )}

                {subtitle && (
                    <Text
                        color="gray.500"
                        fontSize="sm"
                    >
                        {subtitle}
                    </Text>
                )}
            </Flex>
        </Card>
    );
};

export default StatCard;